<template>
  <div class="layout new-calculation">
    <m-confirm
      :modal-confirm="true"
      :active="isShowConfirmModal"
      :modal-title="''"
      :modal-description="
        'На эту дату уже есть сохраненный расчет. Заменить его?'
      "
      confirm-button-label="Сохранить"
      @close="isShowConfirmModal = false"
      @removeItemRequest="confirmRequestSaveCalculation"
    />
    <div class="layout-header">
      <div class="layout-title">
        {{
          $route.query.calc_id
            ? 'Сохраненный расчет' +
              (filialLocalValue && filialLocalValue.label
                ? ' по филиалу ' +
                  filialLocalValue.label +
                  (periodLocalValue.length > 0
                    ? ' за ' +
                      $refs.calculationPeriod.period.start.input +
                      ' - ' +
                      $refs.calculationPeriod.period.end.input
                    : '')
                : '')
            : switcherLocalValue === 'byDate'
              ? 'Новый расчет'
              : switcherLocalValue === 'byPeriod'
                ? 'Новая расчетная смена' +
                  (filialLocalValue && filialLocalValue.label
                    ? ' по филиалу ' +
                      filialLocalValue.label +
                      (periodLocalValue.length > 0
                        ? ' за ' +
                          $refs.calculationPeriod.period.start.input +
                          ' - ' +
                          $refs.calculationPeriod.period.end.input
                        : '')
                    : '')
                : 'Новый расчет'
        }}
      </div>
      <div class="layout-header-actions">
        <div class="layout-header-action">
          <c-button
            size="small"
            :responsive="true"
            icon="back"
            type="with-icon"
            label="К списку расчетов"
            @click="openCalculationsList"
          />
        </div>
      </div>
    </div>
    <div
      class="new-calculation-params"
      :class="{
        'new-calculation-params-required':
          dateSettlementErrorLocal.length > 0 ||
          timeStartErrorLocal.length > 0 ||
          timeEndErrorLocal.length > 0
      }"
    >
      <div class="new-calculation-params-part">
        <c-input
          v-model="filialLocalValue"
          class="new-calculation-params-filial"
          :class="{
            'new-calculation-params-filial-pb-30':
              switcherLocalValue === 'byPeriod'
          }"
          type="select"
          :searchable="true"
          :items="filialLocalItems"
          placeholder="Выберите филиал"
          label="Филиал"
        />
        <c-switcher
          v-model="switcherLocalValue"
          class="new-calculation-params-switcher"
          :class="{
            'new-calculation-params-switcher-pb-30':
              switcherLocalValue === 'byPeriod'
          }"
          type="group"
          :items="[
            { label: 'На дату', value: 'byDate' },
            { label: 'За период', value: 'byPeriod' }
          ]"
        />
        <c-input
          v-if="switcherLocalValue === 'byPeriod'"
          ref="calculationPeriod"
          v-model="periodLocalValue"
          class="new-calculation-params-period"
          :class="{
            'new-calculation-params-period-pb-30':
              switcherLocalValue === 'byPeriod'
          }"
          label="Период"
          placeholder="00.00.0000 - 00.00.0000"
          type="period-without-fixed-intervals"
          icon="calendar"
          :clearable="true"
          :icon-right="true"
          :required-message="periodLocalError"
          :required="periodLocalError"
        />
        <c-input
          v-if="switcherLocalValue === 'byDate'"
          ref="dateInputNewCalculation"
          v-model="dateSettlementLocal"
          class="new-calculation-params-date-settlement"
          label="Расчeт на дату"
          :editable="true"
          type="date"
          format="DD.MM.YYYY, dddd"
          icon="calendar"
          placeholder="00.00.0000"
          :required="dateSettlementErrorLocal"
          :icon-right="true"
          @invalidDate="sendErrorDateMessage"
        />
      </div>
      <div class="new-calculation-params-part">
        <div class="shift">
          <c-input
            v-if="switcherLocalValue === 'byDate'"
            v-model="shiftTypeLocalValue"
            class="new-calculation-params-shift-type"
            type="select"
            placeholder="Выберите тип смены"
            :items="shiftTypeLocalItems"
            label="Смена"
          />
          <div
            v-if="switcherLocalValue === 'byDate'"
            class="new-calculation-params-time"
          >
            <c-input
              v-model="timeStart"
              class="new-calculation-params-time-start"
              :class="{
                'new-calculation-params-time-start-required':
                  timeStartErrorLocal.length > 0
              }"
              type="text"
              :mask="'##:##'"
              placeholder="00:00"
            />
            <span>−</span>
            <c-input
              v-model="timeEnd"
              class="new-calculation-params-time-end"
              :class="{
                'new-calculation-params-time-end-required':
                  timeEndErrorLocal.length > 0
              }"
              type="text"
              :mask="'##:##'"
              placeholder="00:00"
            />
            <div
              v-if="timeErrorLocal.length > 0"
              class="new-calculation-params-time-error-message"
            >
              <svg
                class="new-calculation-params-time-error-message-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="7"
                  cy="7"
                  r="6.5"
                  fill="white"
                  stroke="#FF238D"
                ></circle>
                <circle cx="7" cy="10" r="1" fill="#FF238D"></circle>
                <rect
                  x="6"
                  y="3"
                  width="2"
                  height="5"
                  rx="1"
                  fill="#FF238D"
                ></rect>
              </svg>
              <div class="new-calculation-params-time-error-message-text">
                {{ timeErrorLocal }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-calculation-params-buttons"
          :class="{
            'new-calculation-params-buttons-mt-0':
              switcherLocalValue === 'byPeriod'
          }"
        >
          <c-button
            class="new-calculation-params-buttons-calc"
            :disabled="isDataLoading"
            :label="
              switcherLocalValue === 'byDate' ? 'Рассчитать' : 'Рассчитать'
            "
            color="primary"
            @click="calculate"
          />
          <c-button-dropdown
            v-if="switcherLocalValue === 'byDate' && false"
            class="new-calculation-params-buttons-time"
            type="dropdown"
            icon="arrow"
            :dropdown="{
              position: 'left',
              items: [
                { label: 'На текущий момент', emit: 'calculate', value: 'now' },
                {
                  label: 'С настройками на дату расчета',
                  emit: 'calculate',
                  value: 'past'
                }
              ]
            }"
            @calculate="calculate"
          />
          <c-button-dropdown
            v-if="!isDataLoading && isShowMainTable"
            class="new-calculation-params-buttons-time"
            type="dropdown"
            icon="arrow"
            :dropdown="{
              position: 'left',
              items: [
                { label: 'Рассчитать на сейчас', emit: 'calculate', value: 'calcnow' },
                { label: 'Печать', emit: 'calculate', value: 'print' },
                //  { label: 'Расчетный лист', emit: 'calculate', value: 'calc' },
                { label: 'Для фото', emit: 'calculate', value: 'photo' },
                { label: 'Excel', emit: 'calculate', value: 'excel' },
              ]

            }"
            @calculate="calculate"
          />
        </div>

        <div class="new-calculation-params-hide-show-block">
          <c-button
            v-if="
              !isDataLoading &&
                isShowMainTable &&
                tableData.columns.length > 0 &&
                tableData.records.length > 0
            "
            :disabled="isDataLoading"
            :label="isShowTable ? 'Скрыть таблицу' : 'Показать таблицу'"
            icon="google-grey"
            type="with-icon"
            @click="toggleTable"
          />
        </div>

      </div>
    </div>
    <c-loader
      v-if="isDataLoading"
      class="new-calculation-loader"
      label="Производится расчёт"
      :active="isDataLoading"
      height="500"
    />
    <c-data-table-create-calculation
      v-if="
        !isDataLoading &&
          isShowMainTable &&
          tableData.columns.length > 0 &&
          tableData.records.length > 0 &&
          isShowTable
      "
      ref="table"
      class="new-calculation-table"
      :levels="1"
      :personal-reasons="personalReasons"
      :calc-data="calcData"
      :disabled-columns="[]"
      :data="tableData"
      :drivers-columns="driversColumns"
      :production-columns="productionColumns"
      :drivers-columns-disabled="driversColumnsDisabled"
      :production-columns-disabled="productionColumnsDisabled"
      @salmon="salmon"
      @loadvalue="loadvalue"
      @disabledColumnsEvent="disabledColumnsEvent"
    />
    <div v-if="!isDataLoading && isShowMainTable" class="new-calculation-tabs">
      <c-tabs
        ref="tab"
        :active="activeTab"
        :items="tabs"
        with-routing
        @change="changeTab"
      />
    </div>

    <div
      v-if="!isDataLoading && isShowMainTable"
      class="new-calculation-content"
    >
      <router-view
        :key="$route.path"
        ref="route"
        :chapter="activeTab"
        :disabled-saved="disabledSaved"
        :personal-reasons="personalReasons"
        :tab="switcherLocalValue"
        :can-edit="canEdit"
        :data="calcData"
        :change-calc="changeCalc"
        :time-start="timeStart"
        :time-end="timeEnd"
        :drivers-columns="driversColumns"
        :production-columns="productionColumns"
        :drivers-columns-disabled="driversColumnsDisabled"
        :production-columns-disabled="productionColumnsDisabled"
        :filialLocalValue="filialLocalValue"
        :is-closed="isClosed"
        :can-close="canClose && !!$route.query.calc_id"
        :is-toggling-closed="isTogglingClosed"
        @toggleClosed="toggleCalculationClosed"
        @updateDriversCount="updateDriversCount"
        @updateKPItable="updateKPItable"
        @sendActivePosts="activatePosts"
        @saveCalculation="saveCalculation"
        @cancelCalculation="cancelCalculation"
        @changeDriver="changeDriver"
        @recountRoutes="recountRoutes"
        @disabledColumnsEvent="disabledColumnsEvent"
      />
    </div>
  </div>
</template>
<script>

import Button from '@/components/controls2/Button';
import ButtonDropdown from '@/components/controls/button-dropdown';
import Input from '@/components/controls2/Input';
import Select from '@/components/controls2/Select';
import loader from '@/components/loader';
import Tabs from '@/components/tabs';
import Switcher from '@/components/controls2/Switcher';
import DataTableCreateCalculation from '@/pages/calculations/create/additions/data-table-create-calculation';
import ConfirmModal from '@/pages/positions/items-modal';
import moment from 'moment';
import {mapGetters} from 'vuex';
import {
  initFromCRM,
  initSaved,
  findPostProduction,
  eventChangeIntervalSmena,
  eventChangeSmena, getProductionProceedsOfficeNormday,
} from '@/entities/models/calculations';

export default {
  name: 'save-calculation',
  components: {
    'c-button': Button,
    'c-button-dropdown': ButtonDropdown,
    'c-input': Input,
    'c-select': Select,
    'c-switcher': Switcher,
    'c-loader': loader,
    'c-tabs': Tabs,
    'c-data-table-create-calculation': DataTableCreateCalculation,
    'm-confirm': ConfirmModal,
  },

  beforeRouteUpdate(to, from, next) {
    if (this.$refs.route !== undefined) this.$refs.route.collectCalculation();
    next();
  },
  data() {
    return {
      disabledSaved: false,
      canEdit: false,
      isClosed: false,
      canClose: false,
      isTogglingClosed: false,
      delayed: null,
      dparams: null,
      total: null,
      prodWorkers: null,
      allDrivers: null,
      drivers: null,
      calcId: null,
      driversColumns: null,
      productionColumns: null,
      driversColumnsDisabled: [],
      productionColumnsDisabled: [],
      calcData: null,
      switcherLocalValue: this.$route.query.tab
        ? this.$route.query.tab
        : 'byDate',
      periodLocalValue: '',
      periodLocalError: '',
      isShowConfirmModal: false,
      periodStart: this.$route.query.periodStart
        ? this.$route.query.periodStart
        : '',
      periodEnd: this.$route.query.periodEnd ? this.$route.query.periodEnd : '',
      isDataLoading: false,
      isFirstLoading: false,
      isShowMainTable: false,
      isCheckExists: true,
      filialLocalValue: null,
      filialLocalItems: [],
      dateSettlementLocal: '',
      dateSettlementErrorLocal: '',
      shiftTypeLocalValue: null,
      shiftTypeLocalItems: [
        {label: 'Дневная', value: 1},
        {label: 'Ночная', value: 2},
      ],
      submitAttempt: false,
      timeStart: '05:00',
      timeEnd: '16:00',
      personalReasons: [],
      timeStartErrorLocal: '',
      timeEndErrorLocal: '',
      activeTab: '',
      is_filial_admin: false,
      tabs:
        this.$route.query.tab === 'byDate' || !this.$route.query.tab
          ? [
            {
              label: 'Производство',
              value: 'save-calculation-production',
              query: {
                calc_id: this.$route.query.calc_id,
                tab: this.$route.query.tab,
              },
            },
            {
              label: 'Доставка',
              value: 'save-calculation-delivery',
              query: {
                calc_id: this.$route.query.calc_id,
                tab: this.$route.query.tab,
              },
            },
            // {
            //   label: 'Опоздания',
            //   value: 'save-calculation-lateness',
            //   query: {
            //     calc_id: this.$route.query.calc_id,
            //     tab: this.$route.query.tab,
            //   },
            // },
          ]
          : [
            {
              label: 'Производство',
              value: 'save-calculation-production',
              query: {
                calc_id: this.$route.query.calc_id,
                periodStart: this.$route.query.periodStart,
                periodEnd: this.$route.query.periodEnd,
                tab: this.$route.query.tab,
                smena: this.$route.query.smena,
              },
            },
            {
              label: 'Доставка',
              value: 'save-calculation-delivery',
              query: {
                calc_id: this.$route.query.calc_id,
                periodStart: this.$route.query.periodStart,
                periodEnd: this.$route.query.periodEnd,
                tab: this.$route.query.tab,
                smena: this.$route.query.smena,
              },
            },
          ],
      tableData: {
        columns: [],
        userColumns: null,
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
      isShowTable: false,
    };
  },

  async created() {

    await this.$store.dispatch('employees/getReferenceValues', 'filial').then(res => {
      this.filialLocalItems = res.data.map(item => ({id: item.id, value: item.id, label: item.name}));
      this.filialLocalValue = this.filialLocalItems[0];
    });
  },

  computed: {
    ...mapGetters('calculations', [
      'getTableMainTableCalculationByDate',
      'getTableMainTableCalculationByPeriod',
    ]),

    timeErrorLocal() {
      if (this.timeStartErrorLocal.length > 0) {
        return this.timeStartErrorLocal;
      } if (this.timeEndErrorLocal.length > 0) {
        return this.timeEndErrorLocal;
      } 
      return '';
      
    },
  },

  watch: {
    switcherLocalValue(value) {

      if (value === 'byDate' || !value) {
        if (!this.isDataLoading && !this.isFirstLoading)
          this.isShowMainTable = false;

        this.tabs = [
          {
            label: 'Производство',
            value: 'save-calculation-production',
            query: {},
          },
          {
            label: 'Доставка',
            value: 'save-calculation-delivery',
            query: {},
          },
          // {
          //   label: 'Опоздания',
          //   value: 'save-calculation-lateness',
          //   query: {},
          // },
        ];
        setTimeout(() => {
          this.periodLocalValue = '';
          this.periodStart = '';
          this.periodEnd = '';
        }, 300);

        this.$nextTick(() => {
          this.dateSettlementLocal = moment().format('DD.MM.YYYY');
          if (this.$refs.dateInputNewCalculation)
            this.$refs.dateInputNewCalculation.setCurrentDateInputTypeDate();
        });
      } else {
        // this.isShowMainTable = false
        if (!this.isDataLoading && !this.isFirstLoading)
          this.isShowMainTable = false;

        this.tabs = [
          {
            label: 'Производство',
            value: 'save-calculation-production',
            query: {calc_id: this.$route.query.calc_id},
          },
          {
            label: 'Доставка',
            value: 'save-calculation-delivery',
            query: {calc_id: this.$route.query.calc_id},
          },
        ];
        setTimeout(() => {
          this.$refs.calculationPeriod.periodReset();
          this.$refs.calculationPeriod.clear();
          this.periodLocalValue = '';
          this.periodStart = '';
          this.periodEnd = '';
        }, 300);
      }
      setTimeout(() => {
        this.checkExists();
      }, 500);
    },

    filialLocalValue(value) {
      const calcId = this.$route.query.calc_id;

      if (calcId) {
        if (this.calcData !== null) {
          const c = this.calcData.calc ? this.calcData.calc : this.calcData.period;
          if (
            c.calculation.filial_id !== value.value
          ) {
            this.isShowMainTable = false;
          }

        }
      } else {
        this.isShowMainTable = false;
      }
      this.checkExists();
    },

    shiftTypeLocalValue(value) {
      eventChangeSmena(value, this.calcData);
      if (value !== null && value.value === 1) {
        this.timeStart = '05:00';
        this.timeEnd = '16:00';
      } else if (value !== null) {
        this.timeStart = '16:00';
        this.timeEnd = '05:00';
      }
      this.checkExists();
    },

    dateSettlementLocal(value) {
      if (this.submitAttempt) {
        if (value.length === 0) {
          this.dateSettlementErrorLocal = 'Обязательное поле';
        } else if (value.length < 10) {
          this.dateSettlementErrorLocal = 'Неверный формат';
        } else {
          this.dateSettlementErrorLocal = '';
        }
      }
      this.checkExists();
    },

    periodLocalValue(value) {
      // if (!this.isDataLoading) this.isShowMainTable = false
      if (this.submitAttempt) {
        if (value.length === 0) {
          this.periodLocalError = 'Обязательное поле';
        } else {
          this.periodLocalError = '';
        }
      }
      this.checkExists();
    },

    timeStart(value) {
      eventChangeIntervalSmena(value, this.timeEnd, this.calcData);
      if (this.submitAttempt) {
        if (value.length === 0) {
          this.timeStartErrorLocal = 'Некорректно задан интервал';
        } else if (value.length < 5) {
          this.timeStartErrorLocal = 'Некорректно задан интервал';
        } else if (!moment(value, 'H:mm').isValid()) {
          this.timeStartErrorLocal = 'Некорректно задан интервал';
        } else {

          this.timeStartErrorLocal = '';
        }
      }
    },

    $route(value) {
      const calcId = this.$route.query.calc_id;
      this.activeTab = value.name.split('-')[2];

      setTimeout(() => {
        const calcData = JSON.parse(JSON.stringify(this.calcData));
        this.calcData = {};
        this.calcData = calcData;
      }, 500);
    },

    timeEnd(value) {
      eventChangeIntervalSmena(this.timeStart, value, this.calcData);

      if (this.submitAttempt) {
        if (value.length === 0) {
          this.timeEndErrorLocal = 'Некорректно задан интервал';
        } else if (value.length < 5) {
          this.timeEndErrorLocal = 'Некорректно задан интервал';
        } else if (!moment(value, 'H:mm').isValid()) {
          this.timeEndErrorLocal = 'Некорректно задан интервал';
        } else {
          this.timeEndErrorLocal = '';
        }
      }
    },
  },

  async created() {
    if (this.$route.query.tab === 'byDate' || !this.$route.query.tab) {
      this.tabs = [
        {
          label: 'Производство',
          value: 'save-calculation-production',
          query: {
            calc_id: this.$route.query.calc_id,
            tab: this.$route.query.tab,
          },
        },
        {
          label: 'Доставка',
          value: 'save-calculation-delivery',
          query: {
            calc_id: this.$route.query.calc_id,
            tab: this.$route.query.tab,
          },
        },
        // {
        //   label: 'Опоздания',
        //   value: 'save-calculation-lateness',
        //   query: {
        //     calc_id: this.$route.query.calc_id,
        //     tab: this.$route.query.tab,
        //   },
        // },
      ];
    } else {

      this.tabs = [
        {
          label: 'Производство',
          value: 'save-calculation-production',
          query: {
            calc_id: this.$route.query.calc_id,
            periodStart: this.$route.query.periodStart,
            periodEnd: this.$route.query.periodEnd,
            tab: this.$route.query.tab,
            smena: this.$route.query.smena,
          },
        },
        {
          label: 'Доставка',
          value: 'save-calculation-delivery',
          query: {
            calc_id: this.$route.query.calc_id,
            periodStart: this.$route.query.periodStart,
            periodEnd: this.$route.query.periodEnd,
            tab: this.$route.query.tab,
            smena: this.$route.query.smena,
          },
        },
      ];
    }

    await this.$store.dispatch('employees/getReferenceValues', 'filial').then((res) => {
      this.filialLocalItems = res.data.map((item) => ({id: item.id, value: item.id, label: item.name}));
      const [firstFilial] = this.filialLocalItems;
      if (this.$route.query.calc_id) {
        this.filialLocalValue = null;
      } else {
        this.filialLocalValue = firstFilial;
      }
    });
  },

  mounted() {
    if (this.periodStart.length > 0 && this.periodEnd.length > 0) {
      this.$refs.calculationPeriod.period.start.input = this.periodStart;
      this.$refs.calculationPeriod.period.end.input = this.periodEnd;
      this.$refs.calculationPeriod.dateValue = `${this.periodStart}-${this.periodEnd}`;
    }

    this.$store.dispatch('personalEmployee/getReasonsListForTransactionPersonalAccountModal').then((res) => {
      this.personalReasons = res.response;
    });

    const userPermissions = this.$store.getters.getUserPermissions;
    this.canEdit = true; // userPermissions.some((permission) => permission === "CalculationManagement" || permission=="CalculationManagementFilial");

    if (this.$route.query.calc_id) {
      this.isShowMainTable = false;
      this.isDataLoading = true;
      this.isFirstLoading = true;

      const calcId = this.$route.query.calc_id;
      this.filialLocalValue = null;

      this.$store.dispatch('calculations/getCalc', calcId).then((res) => {
        this.isClosed = !!res.is_closed;
        this.canClose = !!res.can_close;
        this.canEdit = !this.isClosed;
        this.calcId = calcId;

        if(res && res.is_filial_admin) {
          this.tabs.push(
            {
              label: 'Опоздания',
              value: 'save-calculation-lateness',
              query: {
                calc_id: this.$route.query.calc_id,
                tab: this.$route.query.tab,
              },
            },
          );
        }

        if (!res.calc && !res.period) {
          this.$router.push({
            name: 'calculation-error-404',
          }).catch(() => {
          });
        }

        if (!res.calc) {
          if (res.period.calculation.smena === 3) {
            this.$store.dispatch('calculations/getUserColumnsByType', 'calc_production').then(res => {
              this.productionColumns = res.columns;
            });
            this.$store.dispatch('calculations/getUserColumnsByType', 'calc_drivers').then(res => {
              this.driversColumns = res.columns;
            });

            this.switcherLocalValue = 'byPeriod';
            if (res.period.calculation.filial_id) {
              const findIndexFilial = this.filialLocalItems.findIndex(
                (filial) => filial.value === res.period.calculation.filial_id,
              );
              this.filialLocalValue = this.filialLocalItems[findIndexFilial];
            }
            setTimeout(() => {
              const formatPeriodStart = moment(res.period.calculation.datetime).format('DD.MM.YYYY');
              const formatPeriodEnd = moment(res.period.calculation.datetime_end).format('DD.MM.YYYY');
              this.periodStart = formatPeriodStart;
              this.periodEnd = formatPeriodEnd;
              this.$refs.calculationPeriod.period.start.input = this.periodStart;
              this.$refs.calculationPeriod.period.end.input = this.periodEnd;
              this.$refs.calculationPeriod.dateValue = `${this.periodStart}-${this.periodEnd}`;
            }, 500);
          }
        } else {
          this.$store.dispatch('calculations/getUserColumnsByType', 'calc_production_2').then(res => {
            this.productionColumns = res.columns;
          });
          this.$store.dispatch('calculations/getUserColumnsByType', 'calc_drivers').then(res => {
            this.driversColumns = res.columns;
          });
          this.switcherLocalValue = 'byDate';
          if (res.calc.calculation.filial_id) {
            const findIndexFilial = this.filialLocalItems.findIndex(
              (filial) => filial.value === res.calc.calculation.filial_id,
            );
            this.filialLocalValue = this.filialLocalItems[findIndexFilial];
          }

          if (res.calc.calculation.smena) {
            if (res.calc.calculation.smena === 1) {
              const [firstShiftType] = this.shiftTypeLocalItems;
              this.shiftTypeLocalValue = firstShiftType;
            } else {
              const [, secondShiftType] = this.shiftTypeLocalItems;
              this.shiftTypeLocalValue = secondShiftType;
            }
          }

          setTimeout(() => {
            if (res.calc.calculation.date && this.$refs.dateInputNewCalculation) {
              this.$refs.dateInputNewCalculation.setDateInputTypeDate(res.calc.calculation.date);
              this.dateSettlementLocal = res.calc.calculation.date;
            }
            const {timebeg} = res.calc.calculation;
            const {timeend} = res.calc.calculation;
            this.timeStart = timebeg;
            this.timeEnd = timeend;

            initSaved(res);
            // this.activatePosts()
          }, 500);
        }

        this.isDataLoading = false;
        this.isShowMainTable = true;

        this.tabs.forEach((tab) => {
          tab.query = {
            calc_id: this.$route.query.calc_id,
            tab: this.$route.query.tab,
          };
        });

        this.$router.push({
          name: 'save-calculation-production',
          query: {
            calc_id: calcId,
            tab: this.switcherLocalValue,
          },
        }).catch(() => {
        });

        setTimeout(() => {
          this.calcData = res;
          this.isFirstLoading = false;
        }, 300);

        setTimeout(() => {
          this.isCheckExists = false;
        }, 2000);
      });
    } else {
      const [firstFilial] = this.filialLocalItems;
      const [firstShiftType] = this.shiftTypeLocalItems;
      this.filialLocalValue = firstFilial;
      this.shiftTypeLocalValue = firstShiftType;
      this.$nextTick(() => {
        this.dateSettlementLocal = moment().format('DD.MM.YYYY');
        if (this.$refs.dateInputNewCalculation) this.$refs.dateInputNewCalculation.setCurrentDateInputTypeDate();
      });
      this.isCheckExists = false;
    }
  },

  methods: {
    disabledColumnsEvent(data) {
      if (data.t == 'production') {
        this.productionColumnsDisabled = data.c;
      } else {
        this.driversColumnsDisabled = data.c;
      }
    },

    changeDriver(record) {
      this.$store.dispatch('calculations/changeCourier', {
        order_id: record.id,
        courier_id: record.currentDriver.value,
      }).then(res => {
        this.calculate(null);
      });
    },

    recountRoutes() {
      this.calculate(null, 1);
    },

    openCalculationsList() {
      window.open('/?r=redesign', '_self');
    },

    toggleCalculationClosed() {
      const currentCalcId = this.calcId || this.$route.query.calc_id;
      if (!currentCalcId) {
        return;
      }

      this.isTogglingClosed = true;

      this.$store.dispatch('calculations/toggleCalculationClosed', currentCalcId)
        .then((res) => {
          if (res.success) {
            this.isClosed = res.is_closed;
            this.canEdit = !this.isClosed;

            this.$notify({
              group: 'success-message',
              duration: 5000,
              data: {
                textMessage: res.message,
              },
            });
          } else {
            this.$notify({
              group: 'error-message',
              duration: 7000,
              data: {
                textMessage: res.message || 'Ошибка при изменении статуса расчёта',
              },
            });
          }
        })
        .catch(() => {
          this.$notify({
            group: 'error-message',
            duration: 7000,
            data: {
              textMessage: 'Ошибка сети при изменении статуса расчёта',
            },
          });
        })
        .finally(() => {
          this.isTogglingClosed = false;
        });
    },

    changeTab(value) {

    },

    salmon(v) {
      this.$refs.route.salmon(v);
    },

    loadvalue(v) {
      this.$refs.route.loadvalue(v);
    },

    updateDriversCount(count) {
      if (this.switcherLocalValue === 'byPeriod') {
        const findIndexDriversRecord = this.tableData.records.findIndex(
          record => record.postCode === 'driver',
        );
        if (findIndexDriversRecord !== -1)
          this.tableData.records[
            findIndexDriversRecord
          ].employees.value = count;

        this.calculateSumRow();
      }
    },

    updateKPItable(params) {
      if (this.switcherLocalValue === 'byPeriod') {
        let crm_sum = 0;
        const adm = this.calcData.period.production.posts.find((p) => p.post_code == 'administrator');
        if (adm) crm_sum = adm.crm_sum;
        if (params) {
          this.tableData.records.map(record => {
            const findIndexRecord = params.findIndex(
              param => param.code !== undefined && param.code == record.postCode,
            );
            if (findIndexRecord !== -1) {
              record.payments.value = crm_sum > 0 ?
                Math.round(crm_sum ? params[findIndexRecord].toPayoff / crm_sum * 1000 : 0) / 10 :
                0;
              record.employees.value = params[findIndexRecord].employees;
              if (
                this.calcData.period.production.posts &&
                this.calcData.period.production.crm_sum
              ) {
                const c = this.calcData.period.production.posts.findIndex(
                  post => post.post_code === record.postCode,
                );
                record.fotFromProceeds.value =
                  params[findIndexRecord].toPayoff > 0 &&
                  this.calcData.period.production.crm_sum != 0 &&
                  this.calcData.period.production.posts[c] &&
                  this.calcData.period.production.posts[c].crm_sum != 0 &&
                  this.calcData.period.production.posts[c].crm_sum !== null &&
                  this.calcData.period.production.crm_sum !== null
                    ? Math.round(
                      1000 /
                        (Number(this.calcData.period.production.crm_sum) /
                          Number(
                            this.calcData.period.production.posts[c].crm_sum,
                          )),
                    ) / 10
                    : 0;
              }
            }
          });

        }
        const findIndexDriversRecord = this.tableData.records.findIndex(
          record => record.postCode === 'driver',
        );
        if (findIndexDriversRecord !== -1) {
          let s = 0;
          this.calcData.period.drivers.workers.forEach((w) => {
            s += parseFloat(w.orders_sum);
          });
          // alert(this.calcData.period.drivers.orders);
          this.tableData.records[findIndexDriversRecord].fotFromProceeds.value = Number(
            this.calcData.period.drivers.orders) !== 0 ?
            `${Math.round(s / this.calcData.period.drivers.orders) } ฿` :
            0;
          this.tableData.records[findIndexDriversRecord].employees.value = this.calcData.period.drivers.workers.length;
          this.tableData.records[findIndexDriversRecord].payments.value = crm_sum > 0 ?
            Math.round(crm_sum ? this.calcData.period.drivers.sum / crm_sum * 1000 : 0) / 10 :
            0;
        }

      } else {
        const findIndexGroup = this.tableData.records.findIndex(
          record => record.postCode === params.codeGroup,
        );
        this.tableData.records[findIndexGroup].employees.value =
          params.countWorkers;
      }
      this.calculateSumRow();
    },

    calculateSumRow() {
      if (this.switcherLocalValue === 'byDate') {

        const indexSumRow = this.tableData.records.findIndex(
          record => record.isSumRow,
        );
        const {calc} = this.calcData;
        this.tableData.records[indexSumRow].load.value = 0;
        if (calc.production && calc.production.crm_sum) {
          this.tableData.records[indexSumRow].load.value = Math.round(calc.production.crm_sum);
        }

        this.tableData.records[indexSumRow].fotInCategory.value = 0;
        let sum = 0;
        if (calc.production && calc.production.sum) sum += calc.production.sum;
        if (calc.drivers && calc.drivers.sum) sum += calc.drivers.sum;
        let a = findPostProduction('administrator', this.calcData.calc); let admsum = 0;
        if (a && a.crm_sum) admsum = a.crm_sum;
        this.tableData.records[indexSumRow].fotInCategory.value = admsum > 0 ?
          Math.round(sum / admsum * 1000) / 10 :
          '';

        this.tableData.records[indexSumRow].post.value = 'Итого';
        this.tableData.records[indexSumRow].loadType.value = 'Выручка';
        
        if (this.calcData.total && this.calcData.total.sum) {
          this.tableData.records[indexSumRow].pluski = {
            value: Math.round(this.calcData.total.sum.pluski_discount_sum || 0),
          };
          const loadValue = this.tableData.records[indexSumRow].load && this.tableData.records[indexSumRow].load.value 
            ? this.tableData.records[indexSumRow].load.value 
            : 0;
          this.tableData.records[indexSumRow].revenue_plus_bonuses = {
            value: loadValue + Math.round(this.calcData.total.sum.pluski_discount_sum || 0),
            unit: '฿',
          };
        } else {
          this.tableData.records[indexSumRow].pluski = { value: 0 };
          const loadValue = this.tableData.records[indexSumRow].load && this.tableData.records[indexSumRow].load.value 
            ? this.tableData.records[indexSumRow].load.value 
            : 0;
          this.tableData.records[indexSumRow].revenue_plus_bonuses = {
            value: loadValue,
            unit: '฿',
          };
        }

        this.tableData.records[indexSumRow].employees.value = 0;
        this.tableData.records[indexSumRow].hours.value = 0;
        this.tableData.records[indexSumRow].fotFromProceeds.value = '';
        this.tableData.records[indexSumRow].lateness.value[0] = 0;
        this.tableData.records[indexSumRow].lateness.value[1] = 0;
        this.tableData.records[indexSumRow].lateness.value[2] = 0;
        this.tableData.records[indexSumRow].lateness.value[3] = 0;
        this.tableData.records.map(record => {
          if (!record.isSumRow) {
            this.tableData.records[indexSumRow].employees.value += Number(
              record.employees.value,
            );
            this.tableData.records[indexSumRow].hours.value += Number(
              record.hours.value,
            );
            this.tableData.records[indexSumRow].productionRate.value += Number(
              record.productionRate.value,
            );
            this.tableData.records[indexSumRow].lateness.value[0] += Number(
              record.lateness.value[0],
            );
            this.tableData.records[indexSumRow].lateness.value[1] += Number(
              record.lateness.value[1],
            );
            this.tableData.records[indexSumRow].lateness.value[2] += Number(
              record.lateness.value[2],
            );
            this.tableData.records[indexSumRow].lateness.value[3] += Number(
              record.lateness.value[3],
            );
          }
        });
        this.tableData.records[indexSumRow].productionRate.value = 0;

        if (!a) a = findPostProduction('cashier administrator', calc);
        if (a && a.crm_sum) {
          this.tableData.records[indexSumRow].productionRate.value = calc.production.normday > 0 ?
            Math.round((a.crm_sum - calc.production.normday) / calc.production.normday * 100) :
            0;
        }

      } else {
        const indexSumRow = this.tableData.records.findIndex(
          record => record.isSumRow,
        );
        this.tableData.records[indexSumRow].employees.value = 0;
        this.tableData.records[indexSumRow].fotFromProceeds.value = 0;
        this.tableData.records[indexSumRow].payments.value = 0;
        this.tableData.records.map(record => {
          if (!record.isSumRow) {
            this.tableData.records[indexSumRow].payments.value += Number(
              record.payments.value,
            );
            this.tableData.records[indexSumRow].employees.value += Number(
              record.employees.value,
            );
            this.tableData.records[indexSumRow].fotFromProceeds.value += Number(
              record.fotFromProceeds.value,
            );
          }
        });

        const c = this.tableData.records.findIndex(record => record.isSumRow);
        if (c !== -1 && this.tableData.records.length > 1) {
          this.tableData.records[c].fotFromProceeds.value =
            this.tableData.records[c].fotFromProceeds.value === 0
              ? 0
              : Math.round(
                Number(this.tableData.records[c].fotFromProceeds.value) /
                  this.tableData.records.length -
                  1,
              );
        }

        this.tableData.records[indexSumRow].payments.value = Math.round(
          this.tableData.records[indexSumRow].payments.value * 10) / 10;
        this.tableData.records[indexSumRow].fotFromProceeds.value = ''; // Math.round(this.tableData.records[indexSumRow].fotFromProceeds.value*10)/10;
      }
    },

    activatePosts(posts) {
      if (this.switcherLocalValue === 'byDate') {
        this.tableData.columns = [
          ...this.getTableMainTableCalculationByDate.columns,
        ];
        this.tableData.records = [
          ...this.getTableMainTableCalculationByDate.records,
        ];
      } else {
        this.tableData.columns = [
          ...this.getTableMainTableCalculationByPeriod.columns,
        ];

        if (this.tableData.records.length == 0)
          this.tableData.records = [
            ...this.getTableMainTableCalculationByPeriod.records,
          ];
      }

      var allSum = 0;
      const calc = this.switcherLocalValue === 'byDate' ? this.calcData.calc : this.calcData.period;
      var post = null;// findPostProduction("administrator", this.calcData.calc);
      if (post && post.crm_sum) allSum = post.crm_sum;
      if (calc.production && calc.production.crm_sum) {
        allSum = calc.production.crm_sum;
      }

      const findIndexDriversRecord = this.tableData.records.findIndex(
        record => record.postCode === 'driver',
      );

      if (this.switcherLocalValue === 'byDate') {
        this.tableData.records[findIndexDriversRecord].employees.value = this.calcData.calc.drivers.workers.length;
        const d = this.calcData.calc.drivers;
        if ('crm_sum' in d) {
        }
        var post = findPostProduction('administrator', this.calcData.calc);
        let ccc = 0; var allSum = 0;
        if (post && post.crm_sum) {
          ccc = post.crm_sum;
          allSum = ccc;
        }
        if (this.calcData.calc.production && this.calcData.calc.production.crm_sum) {
          allSum = this.calcData.calc.production.crm_sum;
        }
        const row = this.tableData.records[findIndexDriversRecord];
        setTimeout(() => {
          if ('crm_sum' in d) {
            ccc = d.crm_sum;
          }
          row.productionRate.value = Math.round((allSum > 0 && ccc > 0 ? ccc / allSum * 100 : 0) * 10) / 10;// d.sum_percent d.duration>0 ? Math.round(d.plan_duration / d.duration * 100)/10 : 0;
          row.load.value = Math.round(d.crm_sum);
          row.fotInCategory.value = d.crm_sum ? Math.round(d.sum / d.crm_sum * 1000) / 10 : 0;
        }, 300);
        this.tableData.records[findIndexDriversRecord].hours.value = d.worktime ? Math.round(d.worktime * 10) / 10 : '';
        this.tableData.records[findIndexDriversRecord].additionalLoad.value = Math.round(
          d.worktime > 0 ? (d.worktime - d.duration) / d.worktime * 100 : 0);
        if (d) this.tableData.records[findIndexDriversRecord].fotFromProceeds.value = `Цена заказа ${ 
          Math.round((d.orders > 0 ? d.sum_round / d.orders : 0)) }฿`;
      }

      const sp = this.calcData.settings.production;
      posts.sort((a, b) => {
        let p1 = 0;
        let p2 = 0;
        if (sp[a.code]) p1 = sp[a.code].position;
        if (sp[b.code]) p2 = sp[b.code].position;
        return p1 < p2 ? 1 : -1;
      });
      /*
    this.calcData.calc.production.posts.forEach((post)=>{
      let s = sp[post.post_code].s;
      post["type_load_name"] = '';
      if ("type_load_name" in s && s["type_load_name"]) {
        post["type_load_name"] = s["type_load_name"];
      }
      post["type_load_is_system"] = 1;
      if ("type_load_is_system" in s) {
        post["type_load_is_system"] = s["type_load_is_system"];
      }

    }) */

      posts.map(post => {
        const c = this.tableData.records.findIndex(
          (record) => record.postCode == post.code,
        );
        let countWorkers = 0;
        let paymentSum = 0;
        let lateness = [0, 0, 0, 0];

        if (this.switcherLocalValue === 'byDate') {

          this.calcData.calc.production.workers.map(worker => {
            if (worker.post_code === post.code) countWorkers += 1;
          });

          this.calcData.calc.delayed.posts.map(latenessPost => {
            if (latenessPost.post_code === post.code) {
              lateness = latenessPost.values;
            }
          });
        } else {
          this.calcData.period.production.workers.map(worker => {
            if (worker.post_code === post.code) {
              paymentSum += Math.round(worker.sum_paid);
              countWorkers += 1;
            }
          });
        }

        let p = null;

        if (post.isActive)
          p = this.switcherLocalValue === 'byDate' ?
            this.calcData.calc.production.posts.find(w => w.post_code == post.code) :
            this.calcData.period.production.posts.find(w => w.post_code == post.code);

        if (post.isActive && p) {

          let normdayp = p.normday;
          if (this.switcherLocalValue === 'byDate') {
            if (p.post_code == 'suhi' || p.post_code == 'STsuhi' || p.post_code == 'Suhihot') {
              const pst = findPostProduction('STsuhi', this.calcData.calc);
              const pst2 = findPostProduction('suhi', this.calcData.calc);
              const pst3 = findPostProduction('Suhihot', this.calcData.calc);
              if (pst && pst2 && pst3) {
                normdayp = pst.normday + pst2.normday + pst3.normday;
                p.crm_sum = pst2.crm_sum;
              }
            }
          }
          let normday = 0;
          if (p) normday = p.normday > 0 ?
            Math.round((p.crm_sum + p.s_salmon * p.salmon - normdayp) / normdayp * 100) :
            0;
          if (p && p.post_code == 'pizzamaker') {
            normday = p.normday ? Math.round((p.count_products - p.normday) / p.normday * 100) : 0;
          }

          let proceeds_office_normday = 0;
          if (this.calcData && this.calcData.calc) {
            if (this.calcData.calc.production && 'proceeds_office_normday' in this.calcData.calc.production)
              proceeds_office_normday = this.calcData.calc.production.proceeds_office_normday;
            else if (this.calcData.calc) {
              proceeds_office_normday = getProductionProceedsOfficeNormday(this.calcData.calc);
            }
          }
          // console.log(proceeds_office_normday, post.crm_sum, post.salmon, post.s_salmon);

          if (p && p.type_load == 'proceeds_office') {
            normday = proceeds_office_normday > 0 ?
              Math.round(
                (p.crm_sum + p.s_salmon * p.salmon - proceeds_office_normday) / proceeds_office_normday * 100) :
              0;
          }

          let crm_sum = 0;
          if (p) crm_sum = Math.round(p.crm_sum);

          const a = findPostProduction('administrator',
                                       this.switcherLocalValue === 'byDate' ? this.calcData.calc : this.calcData.period); let admsum = 0;
          if (a && a.crm_sum) admsum = a.crm_sum;
          const fotInCategory = admsum > 0 ? Math.round(p.sum / admsum * 1000) / 10 : '';
          if (p && post.code == 'pizzamaker') crm_sum = p.count_products;
          lateness[3] = lateness[0] + lateness[1] + lateness[2];

          if (c === -1) {
            if (this.switcherLocalValue === 'byDate') {
              this.tableData.records.unshift({
                postCode: post.code,
                post: {
                  value: post.name,
                },
                loadType: {
                  value: p.type_load_is_system ? (post.code === 'pizzamaker' ? 'Пиццы' : 'Выручка') : p.type_load_name,
                  is_system: p.type_load_is_system,
                },
                load: {
                  value: crm_sum,
                  unit: post.code === 'pizzamaker' || (!p.type_load_is_system && p.type_load_unit == 1) ? 'шт.' : '฿',
                },
                additionalLoad: {
                  value:
                    post.code === 'suhi'
                      ? p.salmon
                      : 0,
                },
                pluski: {
                  value:
                    (post.code.includes('administrator') || post.code === 'admin_smeny') && this.calcData.total && this.calcData.total.sum
                      ? Math.round(this.calcData.total.sum.pluski_discount_sum || 0)
                      : '',
                },
                revenue_plus_bonuses: {
                  value:
                    (post.code.includes('administrator') || post.code === 'admin_smeny') && this.calcData.total && this.calcData.total.sum
                      ? crm_sum + Math.round(this.calcData.total.sum.pluski_discount_sum || 0)
                      : crm_sum,
                  unit: post.code === 'pizzamaker' || (!p.type_load_is_system && p.type_load_unit == 1) ? 'шт.' : '฿',
                },
                employees: {
                  value: countWorkers,
                },
                hours: {
                  value: p && p.worktime ? Math.round(p.worktime * 10) / 10 : '',
                },
                fotInCategory: {
                  value: fotInCategory,
                },
                fotFromProceeds: {
                  value: allSum > 0 && p.crm_sum > 0 ? Math.round(p.crm_sum / allSum * 1000) / 10 : '',
                },
                productionRate: {
                  value: normday,
                },
                lateness: {
                  value: lateness,
                },
                isShowRow: true,
              });
            } else {
              this.tableData.records.unshift({
                postCode: post.code,
                post: {
                  value: post.name,
                },
                loadType: {
                  value: post.code === 'pizzamaker' ? 'Пиццы' : 'Выручка',
                },
                pluski: {
                  value: '',
                },
                employees: {
                  value: countWorkers,
                },
                hours: {
                  value: 0,
                },
                fotFromProceeds: {
                  value: 100,
                },
                payments: {
                  value: paymentSum,
                },
                isShowRow: true,
              });
            }
          }

          if (this.switcherLocalValue === 'byDate') {
            this.calcData.calc.delayed.posts.map(latenessPost => {
              if (latenessPost.post_code === 'driver') {
                const c = this.tableData.records.findIndex(
                  record => record.postCode === 'driver',
                );
                if (c !== -1) {
                  lateness = latenessPost.values;
                  lateness[3] = lateness[0] + lateness[1] + lateness[2];

                  //                  lateness[3] = lateness.reduce((a, b) => a + b, 0);
                  this.tableData.records[c].lateness.value = lateness;
                }
              }
            });
          }
        } else if (c !== -1) {
          this.tableData.records.splice(c, 1);
        }
      });
      this.calculateSumRow();
    },

    isValidHHMMtime(str) {
      return /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(str);
    },

    sendErrorDateMessage(e) {
      if (e)
        this.dateSettlementErrorLocal = 'Неверный формат';
    },

    checkExists() {
      if (!this.isCheckExists && !this.isDataLoading) {
        if (this.filialLocalValue) {
          const smena = this.switcherLocalValue !== 'byDate' ? 3 : this.shiftTypeLocalValue.value;
          let date = null;
          if (smena !== 3) {
            if (this.dateSettlementLocal) {
              // console.log(this.dateSettlementLocal);
              date = moment(this.dateSettlementLocal, 'DD.MM.YYYY').format('YYYY-MM-DD');
            }
          } else {
            this.periodStart = this.$refs.calculationPeriod && this.$refs.calculationPeriod.period ?
              this.$refs.calculationPeriod.period.start.input :
              null;
            if (this.periodStart) {
              date = moment(this.periodStart, 'DD.MM.YYYY').format('YYYY-MM-DD');
            }
          }
          if (date) {
            this.isCheckExists = true;
            this.$store.dispatch('calculations/checkExists', {
              id: this.filialLocalValue.value,
              date,
              smena,
            }).then(res => {
              if (res == 1) {
                this.$notify({
                  group: 'error-message',
                  data: {
                    textMessage: 'Для этого филиала на эту дату уже есть сохраненный расчет',
                  },
                });
              }
            }).finally(() => {
              this.isCheckExists = false;
            });
          }
        }
      }

    },

    calculate(time, recountRoutes) {
      if (time == 'print' || time == 'photo' || time == 'excel' || time == 'calc') {
        const calcId = this.$route.query.calc_id;
        if (!calcId) {
          this.$notify({
            group: 'error-message',
            data: {
              textMessage: 'Сначала сохраните расчет',
            },
          });
          return;
        }
        if (time == 'print')
          window.open(`/index.php?r=calculation%2Fview-print&calc_id=${ calcId}`, '_blank');
        else if (time == 'excel')
          window.open(`/index.php?r=calculation%2Findex&calc_id=${ calcId }&export=1&size=3`, '_blank');
        else if (time == 'calc')
          window.open(`/index.php?r=calculation%2Fpayslip&calc_id=${ calcId }&export=1&size=3`, '_blank');
        else
          window.open(`/index.php?r=calculation%2Fview-foto&calc_id=${ calcId}`, '_blank');
        return;
      }
      if (this.switcherLocalValue === 'byDate') {
        this.tableData.columns = [
          ...this.getTableMainTableCalculationByDate.columns,
        ];
        this.tableData.records = [
          ...this.getTableMainTableCalculationByDate.records,
        ];
      } else {
        this.tableData.columns = [
          ...this.getTableMainTableCalculationByPeriod.columns,
        ];
        this.tableData.records = [
          ...this.getTableMainTableCalculationByPeriod.records,
        ];
      }

      let isValidForm = true;
      const today = moment().format('DD.MM.YYYY');

      if (this.switcherLocalValue === 'byDate') {
        if (this.dateSettlementLocal.length === 0) {
          this.dateSettlementErrorLocal = 'Обязательное поле';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (this.dateSettlementLocal.length < 10) {
          this.dateSettlementErrorLocal = 'Неверный формат';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (!moment(this.dateSettlementLocal, 'DD.MM.YYYY').isValid()) {
          this.dateSettlementErrorLocal = 'Неверный формат';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (this.timeStart.length === 0) {
          this.timeStartErrorLocal = 'Некорректно задан интервал';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (this.timeStart.length < 5) {
          this.timeStartErrorLocal = 'Некорректно задан интервал';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (!moment(this.timeStart, 'H:mm').isValid()) {
          this.timeStartErrorLocal = 'Некорректно задан интервал';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (this.timeEnd.length === 0) {
          this.timeEndErrorLocal = 'Некорректно задан интервал';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (this.timeEnd.length < 5) {
          this.timeEndErrorLocal = 'Некорректно задан интервал';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

        if (!moment(this.timeEnd, 'H:mm').isValid()) {
          this.timeEndErrorLocal = 'Некорректно задан интервал';
          isValidForm = false;
          this.submitAttempt = true;
          return;
        }

      } else if (this.periodLocalValue.length === 0) {
        this.periodLocalError = 'Обязательное поле';
        isValidForm = false;
        this.submitAttempt = true;
        return;
      }

      if (isValidForm) {
        this.isShowMainTable = false;
        this.isDataLoading = true;

        if (this.switcherLocalValue === 'byDate') {
          this.$store.dispatch('calculations/getUserColumnsByType', 'calc_production_2').then(res => {
            this.productionColumns = res.columns;
          });
          this.$store.dispatch('calculations/getUserColumnsByType', 'calc_drivers_2').then(res => {
            this.driversColumns = res.columns;
          });

          this.$store.dispatch('calculations/getAll', {
            filialId: this.filialLocalValue.value,
            date: moment(this.dateSettlementLocal, 'DD.MM.YYYY').format('YYYY-MM-DD'),
            smena: this.shiftTypeLocalValue.value,
            timeStart: this.timeStart,
            timeEnd: this.timeEnd,
            recountRoutes,
          }).then((res) => {
            if (res && res.success === false) {
              this.isDataLoading = false;
              const errorMessage = (res.errors && res.errors.length > 0)
                ? res.errors[0]
                : 'Произошла ошибка при расчёте';
              this.$notify({
                group: 'error-message',
                duration: 7000,
                data: { textMessage: errorMessage },
              });
              return;
            }

            this.isClosed = !!res.is_closed;
            this.canClose = !!res.can_close;
            this.canEdit = !this.isClosed;
            if (res.calc_id) {
              this.calcId = res.calc_id;
            }

            if (this.calcData && 'calc' in this.calcData && this.calcData.calc.calculation.filial_id ==
              this.filialLocalValue.value) {
              res.calc = this.calcData.calc;
            } else {
              res.calc = {
                calculation: {
                  date: moment(this.dateSettlementLocal, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                  filial_id: this.filialLocalValue.value,
                  smena: this.shiftTypeLocalValue.value,
                },
                drivers: {
                  workers: [],
                },
                production: {
                  posts: [],
                  workers: [],
                },
                delayed: {
                  values: [],
                  minh: 8,
                  maxh: 20,
                  posts: [],
                },
              };
            }
            eventChangeIntervalSmena(this.timeStart, this.timeEnd, res);
            res = initFromCRM(res, time == 'calcnow');

            this.isDataLoading = false;
            this.isShowMainTable = true;

            this.tabs.map(tab => {
              tab.query = {
                calc_id: null,
                tab: this.$route.query.tab,
              };
            });

            const name = 'save-calculation-production';
            this.$router.push({
              name,
              query: {
                calc_id: null,
                tab: this.switcherLocalValue,
              },
            }).catch(() => {
              console.log('catch3');
            });

            const name2 = this.activeTab == 'delivery' ? 'save-calculation-delivery' : 'save-calculation-production';
            if (name != name2) {
              setTimeout(() => {
                this.$router.push({
                  name: name2,
                  query: {
                    calc_id: null,
                    tab: this.switcherLocalValue,
                  },
                }).catch(() => {
                });
              }, 1500);
            }

            setTimeout(() => {
              this.calcData = res;
              this.isFirstLoading = false;
            }, 300);

          });
        } else {
          this.periodStart = this.$refs.calculationPeriod.period.start.input;
          this.periodEnd = this.$refs.calculationPeriod.period.end.input;
          const formatPeriodStart = moment(this.periodStart, 'DD.MM.YYYY').format(
            'YYYY-MM-DD',
          );
          const formatPeriodEnd = moment(this.periodEnd, 'DD.MM.YYYY').format(
            'YYYY-MM-DD',
          );
          this.$store.dispatch('calculations/getUserColumnsByType', 'calc_production').then(res => {
            this.productionColumns = res.columns;
          });
          this.$store.dispatch('calculations/getUserColumnsByType', 'calc_drivers').then(res => {
            this.driversColumns = res.columns;
          });

          this.$store.dispatch('calculations/getCountCalc', {
            filialId: this.filialLocalValue.value,
            periodStart: formatPeriodStart,
            periodEnd: formatPeriodEnd,
            tab: this.switcherLocalValue,
            smena: 3,
          }).then(res => {
            const calcData = res;

            this.$router.push({
              name: 'save-calculation-production',
              query: {
                periodStart: this.periodStart,
                periodEnd: this.periodEnd,
                tab: this.switcherLocalValue,
                filialId: this.filialLocalValue.value,
                smena: 3,
              },
            }).then(() => {
            }).catch(() => {
            }).finally(() => {
              this.isDataLoading = false;
              this.isShowMainTable = true;
              setTimeout(() => {
                this.calcData = calcData;
              }, 200);
            });
          });
          
        }
      }
    },

    changeCalc(calc) {
      this.calcData.calc = null;
      setTimeout(() => {
        this.calcData.calc = calc;
      }, 10);
    },

    cancelCalculation() {
      this.openCalculationsList();
    },

    saveCalculation(props) {
      if (this.switcherLocalValue === 'byDate') {

        this.calcData.calc.calculation.smena = this.shiftTypeLocalValue.value;
        this.calcData.calc.calculation.timebeg = this.timeStart;
        this.calcData.calc.calculation.timeend = this.timeEnd;
        if (!this.calcData.calc.calculation.filial_id) this.calcData.calc.calculation.filial_id = this.filialLocalValue.id;
        if (this.dateSettlementLocal) this.calcData.calc.calculation.date = this.dateSettlementLocal;

        let isNeed = true;
        this.calcData.calc.production.workers.forEach((w) => {
          const post = findPostProduction(w.post_code, this.calcData.calc);
          if (isNeed && post) {
            if (w.worktime < post.s_worktime_compens) {
              if (!w.reason_surcharge_id) {
                  alert('Необходимо для всех c короткой сменой указать причину!');
                isNeed = false;
              }
            }
          }
        });
        if (!isNeed) {
          return;
        }
        this.disabledSaved = true;
        this.$store.dispatch('calculations/saveCalculation', {
          calculation: this.calcData.calc,
        }).then(res => {
          if (res.success) {
            this.$notify({
              group: 'success-message',
              duration: 7000,
              data: {
                textMessage: 'Расчет успешно сохранен',
              },
            });
            const newCalcId = res.calc_id;
            this.$store.dispatch('calculations/getCalc', newCalcId).then(res => {
              initSaved(res);
              this.calcData = res;

              this.$router.push({
                name: 'save-calculation-production',
                query: {
                  calc_id: newCalcId,
                  tab: this.switcherLocalValue,
                },
              }).catch(() => {
              });

              this.disabledSaved = false;
              props && props.callback && props.callback();
            });
          } else {
            this.disabledSaved = false;
            const errorMessage = (res.errors && res.errors.length > 0)
              ? res.errors[0]
              : 'Произошла ошибка при сохранении';
            this.$notify({
              group: 'error-message',
              duration: 7000,
              data: {
                textMessage: errorMessage,
              },
            });
          }
        });
      } else {
        this.calcData.period.calculation.date = this.periodStart;
        this.calcData.period.calculation.date_end = this.periodEnd;
        this.calcData.period.calculation.smena = 3;
        this.calcData.period.calculation.timebeg = this.timeStart;
        this.calcData.period.calculation.timeend = this.timeEnd;

        const total = {sum: 0, sum_round: 0, sum_paid: 0};
        Object.entries(this.calcData.period.drivers.workers).forEach(([key, r]) => {
          total.sum += Math.round(parseFloat(r.sum_paid));
          total.sum_round += Math.round(parseFloat(r.sum_paid));
          total.sum_paid += Math.round(parseFloat(r.personal));
        });
        this.calcData.period.drivers.sum = total.sum;
        this.calcData.period.drivers.sum_round = total.sum_round;
        this.calcData.period.drivers.sum_paid = total.sum_paid;
        this.disabledSaved = true;

        this.$store.dispatch('calculations/saveCalculation', {
          calculation: this.calcData.period,
        }).then(res => {
          if (res.confirm !== undefined && !res.confirm) {
            this.isShowConfirmModal = true;
            return;
          }

          if (res.success) {
            this.$notify({
              group: 'success-message',
              duration: 7000,
              data: {
                textMessage: 'Расчет успешно сохранен',
              },
            });
            const newCalcId = res.calc_id;
            this.$store.dispatch('calculations/getCalc', newCalcId).then(res => {
              this.calcData = res;

              this.$router.push({
                name: 'save-calculation-production',
                query: {
                  calc_id: newCalcId,
                  tab: this.switcherLocalValue,
                },
              }).catch(() => {
              });

              this.tabs.map(tab => {
                tab.query = {
                  calc_id: this.$route.query.calc_id,
                  tab: this.$route.query.tab,
                };
                return tab;
              });

              this.disabledSaved = false;
              props && props.callback && props.callback();
            });
          } else {
            this.disabledSaved = false;
            this.$notify({
              group: 'error-message',
              data: {
                textMessage: 'Произошла ошибка при сохранении',
              },
            });
          }
        });
      }
    },

    confirmRequestSaveCalculation() {
      this.isShowConfirmModal = false;
      if (this.switcherLocalValue === 'byDate') {
        this.saveCalculation(1);
      } else {
        this.saveCalculation(1);
      }
    },

    toggleTable() {
      this.isShowTable = !this.isShowTable;
    },
  },
};
</script>
<style lang="scss">
.new-calculation {
  padding: 33px 30px 30px 30px;
  position: relative;

  @media screen and (max-width: 1000px) {
    padding: 33px 30px 30px 30px;
  }

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  &-params {
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
    align-items: flex-end;

    &-part {
      display: flex;
      align-items: flex-end;
    }

    &-required {
      margin-bottom: 23px;

      @media screen and (max-width: 1300px) {
        margin-bottom: 0;
      }
    }

    @media screen and (max-width: 1300px) {
      flex-wrap: wrap;
    }

    &-filial {
      width: 285px;
      flex-shrink: 0;
      // min-width: 156px;
      margin: 0 15px 24px;

      &-pb-30 {
        @media screen and (max-width: 990px) {
          padding-bottom: 30px;
        }
      }

      &::v-deep .c-input-container-list-item-label {
        white-space: normal !important;
      }
    }

    &-switcher {
      margin-left: 30px;
      margin: 0 15px 24px;
      flex-shrink: 0;

      &-pb-30 {
        @media screen and (max-width: 990px) {
          padding-bottom: 30px;
        }
      }

      .c-switcher-group-item {
        background: #ffffff;
      }

      .c-switcher-group-item-label {
        color: #8e9cbb !important;
      }

      .c-switcher-group-item_active {
        color: #333333 !important;
        //border: 2px solid #FF238D !important;
        position: relative;

        & .c-switcher-group-item-label {
          color: #333333 !important;
        }
      }

      .c-switcher-group-item:first-child.c-switcher-group-item_active:after {
        content: "";
        border: 2px solid #ff238d !important;
        position: absolute;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        background: transparent;
        border-radius: 15px 0 0 15px;
        border: 2px solid #ff238d !important;
      }

      .c-switcher-group-item:last-child.c-switcher-group-item_active:after {
        content: "";
        border: 2px solid #ff238d !important;
        position: absolute;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        background: transparent;
        border-radius: 0 15px 15px 0;
        border: 2px solid #ff238d !important;
      }
    }

    &-period {
      margin: 0 15px 24px;

      &-pb-30 {
        @media screen and (max-width: 990px) {
          padding-bottom: 30px;
        }
      }

      ::v-deep & .c-input-container_period-without-fixed-intervals {
        @media screen and (max-width: 1205px) {
          left: 0;
        }
        @media screen and (max-width: 1070px) {
          left: -50px;
        }
        @media screen and (max-width: 990px) {
          left: 0;
          transform: none;
        }
        @media screen and (max-width: 950px) {
          //left: 0;
        }
      }
    }

    &-date-settlement {
      margin: 0 15px 24px;
      width: 120px;
      flex-shrink: 0;
    }

    .shift {
      display: flex;
    }

    &-shift-type {
      margin: 0 15px 24px;
      width: 285px;
      flex-shrink: 0;

      @media screen and (max-width: 767.8px) {
        // margin: 30px 0 0 30px;
        // width: calc(50% - 45px);
      }
    }

    &-time {
      display: flex;
      position: relative;
      align-items: flex-end;
      margin: 0 15px 24px;
      flex-shrink: 0;

      @media screen and (max-width: 767.8px) {
        // margin: 30px 0 0 30px;
        // width: 100%;
      }

      &-start,
      &-end {
        width: 121px;
        flex-shrink: 0;

        .c-input-input {
          text-align: center;
        }

        &::v-deep input {
          text-align: center;
        }

        &::v-deep .c-input-required-text {
          white-space: normal;
        }

        &::v-deep .c-input-required_active {
          bottom: -25px;
        }
      }

      &-start-required,
      &-end-required {
        &::v-deep .c-input-border {
          background: #ff238d;
        }
      }

      & span {
        margin: 0 13px 8px 13px;
      }

      &-error-message {
        position: absolute;
        display: flex;
        align-items: center;
        left: 0;
        height: 14px;
        bottom: -22px;

        &-text {
          white-space: nowrap;
          font-size: 11px;
          color: #ff238d;
          line-height: 108%;
          margin-left: 6px;
          margin-top: 1px;
        }
      }
    }

    &-buttons {
      display: flex;
      margin: 0 15px 24px;

      @media screen and (max-width: 1300px) {
        // margin-left: 30px;
        // width: 30%;
      }

      @media screen and (max-width: 767.8px) {
        // margin-left: 0;
        // width: 100%;
      }

      &-calc {
        width: 135px;

        @media screen and (max-width: 700px) {
          // width: calc(50% - 7.5px);
        }
      }

      &-time {
        margin-left: 15px;

        .c-button {
          .c-button__wrapper {
            height: 38px;
            width: 38px;
            padding: 0;
            border-radius: 50%;
            background: #e1edff;
            border: 0;

            .c-icon {
              margin-left: 3px;

              svg {
                color: #0066ff;

                path {
                  fill: currentColor;
                }
              }
            }
          }

          .c-button__dropdown__container {
            max-width: none;

            &__list__item {
              white-space: nowrap;
            }
          }
        }
      }
    }

    &-hide-show-block {
      margin: 0 15px 24px 0
    }

    @media screen and (max-width: 1200px) {
      &-filial {
        width: 156px;
      }

      &-shift-type {
        width: 156px;
      }

      &-time {
        &-start,
        &-end {
          width: 93px;
        }
      }
    }

    @media screen and (max-width: 767.8px) {
      margin-left: 0;
      margin-right: 0;

      &-part {
        flex-wrap: wrap;
        width: 100%;
      }
      &-filial {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }
      &-switcher {
        width: 100%;
        margin-left: 0;
        margin-right: 0;

        .c-switcher-group {
          width: 100%;

          &-item {
            width: 50%;
          }
        }
      }
      &-date-settlement {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }
      .shift {
        width: calc(100% + 16px);
        margin-left: -8px;
        margin-right: -8px;
      }
      &-shift-type {
        width: auto;
        flex-basis: 50%;
        padding-left: 8px;
        padding-right: 8px;
        margin-left: 0;
        margin-right: 0;
      }
      &-time {
        padding-left: 8px;
        padding-right: 8px;
        margin-left: 0;
        margin-right: 0;
        flex-basis: 50%;

        &-start, &-end {
          width: auto;
          flex-shrink: 1;
        }
      }
      &-buttons {
        margin-left: -7.5px;
        margin-right: -7.5px;
        width: 100%;

        &-calc, &-time {
          flex-basis: 50%;
          margin-left: 7.5px;
          margin-right: 7.5px;
          width: auto;
        }

        &-time {
          .c-button {
            width: 100%;

            &__wrapper {
              width: 100% !important;
              border-radius: 80px !important;
              justify-content: center !important;

              .c-button__icon__right {
                margin: 0 !important;
              }
            }
          }
        }
      }
    }
  }

  &-loader {
    max-width: 1200px;
    margin-top: 30px;

    @media screen and (max-width: 700px) {
      ::v-deep & .loader-overlay {
        width: calc(100% + 40px);
        left: -20px;
        border-right: none;
        border-left: none;
      }
    }
  }

  &-table {
    margin-top: 10px;
  }

  &-tabs {
    margin-top: 50px;
  }
}

</style>